









































































export default {
  props: {
    bonus: {
      type: Object,
    },
  },
}
